export function effectiveDefaultProviderIds(
  enabledServerOrder: string[],
  savedDefaults: string[] | null | undefined,
  providerOrder: string[] | null | undefined,
): string[] {
  const enabledIds = new Set(enabledServerOrder);
  const savedMembership = savedDefaults?.filter((id) => enabledIds.has(id)) ?? [];
  const membership = savedMembership.length > 0 ? savedMembership : enabledServerOrder;
  const effectiveOrder = providerOrder && providerOrder.length > 0
    ? providerOrder
    : enabledServerOrder;
  const orderIndex = new Map(effectiveOrder.map((provider, index) => [provider, index]));

  return membership
    .map((provider, index) => ({ provider, index }))
    .sort((a, b) => {
      const aOrder = orderIndex.get(a.provider) ?? Number.MAX_SAFE_INTEGER;
      const bOrder = orderIndex.get(b.provider) ?? Number.MAX_SAFE_INTEGER;
      return aOrder === bOrder ? a.index - b.index : aOrder - bOrder;
    })
    .map(({ provider }) => provider);
}
